import { faInfoCircle, faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  BoxV4,
  LabraToolTipV2,
  NoteColors,
  NoteV2,
  SelectV4,
} from '@labrav/react-components'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import { SelectChangeEvent, Typography } from '@mui/material'
import clsx from 'clsx'
import { FormikProps, useFormikContext } from 'formik'
import { MsftCombinedFormState } from '../../../../modules/microsoftCombinedForm/reducer'
import { currencyOptions } from '../../../../utils/getCurrencyLabelForDisplay'
import { useMemo } from 'react'
import { useSelector } from '../../../../store'
import { MicrosoftFlyOutListingData } from '../../../../types/flyout'
import _ from 'lodash'
import { useStyles as useCustomStyles } from './PaymentConfiguration.styles'
import { getCurrencyLabelForDisplay } from '../../../../utils/getCurrencyLabelForDisplay'
import { useStyles as useMultiCurrencyFormStyles } from '../../../../common/components/MultiCurrencyForm/MultiCurrencyForm.styles'
import {
  CombinedFormFAQs,
  CombinedFormFAQsItem,
} from '../CombinedFormFAQs/CombinedFormFAQs'

export const PaymentConfiguration = ({ disabled }: { disabled?: boolean }) => {
  const { classes } = useMultiCurrencyFormStyles()
  const { classes: customClasses } = useCustomStyles()
  const formikProps = useFormikContext() as FormikProps<MsftCombinedFormState>
  const { values, setFieldValue, setFieldTouched } = formikProps

  const { microsoftSellerInfo } = useSelector<{
    microsoftSellerInfo: MicrosoftFlyOutListingData
  }>(state => ({
    microsoftSellerInfo: state.flyOutSellerInfoMicrosoft || {},
  }))

  const enabledCurrencies = microsoftSellerInfo?.currencies || []

  const currencyOpts = useMemo(
    () =>
      Object.keys(currencyOptions).map(key => {
        return {
          label: '',
          value: key,
          disabled: true,
          menuItemAction: (
            <div className={classes.menuItems}>
              <Typography>{getCurrencyLabelForDisplay(key)}</Typography>
            </div>
          ),
        }
      }),
    [enabledCurrencies, classes.menuItems]
  )

  const handleCurrencyChange = (event: SelectChangeEvent) => {
    setFieldValue('draftOffer.currency', event.target.value)
    setFieldTouched('draftOffer.currency', true)
  }

  return (
    <BoxV4
      variant="default"
      heading={'Payment configuration'}
      headingIcon={
        <FontAwesomeIcon
          icon={faListCheck}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={
        <CombinedFormFAQs item={CombinedFormFAQsItem.PAYMENT_CONFIGURATION} />
      }
    >
      <>
        <div className={classes.sectionContainer}>
          <div
            className={clsx(classes.textContainer, customClasses.titleWrapper)}
          >
            <Typography
              className={clsx(classes.sectionHeading, classes.fontColor)}
            >
              Select currency
            </Typography>
            <LabraToolTipV2
              tooltipPlacement={'bottom-start'}
              description={
                'You will create offer in the selected currency. Currently only USD is enabled.  And buyer will view equivalent prices in their local currency.'
              }
              tooltipPlacmentGap="12px"
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                style={{
                  height: 16,
                  color: '#6A777A',
                  width: 16,
                  display: 'flex',
                }}
              />
            </LabraToolTipV2>
          </div>
          <div className={customClasses.noteWrapper}>
            <NoteV2
              backgroundColor={NoteColors.YELLOW}
              description={
                <Typography className={classes.noteText}>
                  Buyer will view equivalent prices in their regional currency.
                </Typography>
              }
            />
          </div>
          <div className={classes.selector}>
            <SelectV4
              data-testid="currency-select"
              field={{
                title: 'Select currency',
                placeHolder: 'Select currency',
                id: 'draftOffer.currency',
                isRequired: false,
                humanReadableKey: 'currency',
                isReadOnly: disabled,
                isCustom: false,
                dataType: 'enum' as DataType,
                options: currencyOpts,
                disableOpacity: true,
              }}
              value={getCurrencyLabelForDisplay(
                _.get(values, 'draftOffer.currency', 'USD') as string
              )}
              onChange={handleCurrencyChange}
              showInsideInfoIcon={true}
              showInsideInfoIconTooltip={{
                title: '',
                content: 'You will create offer in the selected currency.',
              }}
            />
          </div>
        </div>
      </>
    </BoxV4>
  )
}
